import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../../Services/APIService';

import {
  AllCampaingsAtom,
  LeadByCampaignsAtom,
  showViewLeadsTableAtom,
  ClientStatusAtom,
  CommentListAtom,
  NewLeadTabFilterAtom,
} from '../../../Services/_states/Machadalo/newLeads';
import { errorAtom } from '../../../Services/_states/alert';
import { dateFormate } from '../../../utils/helper'; 

const newLeadActions = () => {
  const [error, setError] = useRecoilState(errorAtom);
  const AllCampaignList = useSetRecoilState(AllCampaingsAtom);
  const SetClientStatus = useSetRecoilState(ClientStatusAtom);
  const SetCommentListAtom = useSetRecoilState(CommentListAtom);
  const [LeadsByCampaign, setLeadsByCampaign] = useRecoilState(LeadByCampaignsAtom);
  const filters = useRecoilValue(NewLeadTabFilterAtom);

  const getAllCampaigns = async (data) => {
    let params = '&search=' + data.search;
    params += '&lead_type=' + data.lead_type;
    params += '&supplier_type=' + data.supplier_type;
    let res = await APIService.get(`${Apis.New_Leads_Campaign}${params}`);
    if (res.status == 200) {
      const { data } = res;
      AllCampaignList([...data]);
    };
  };
  const getLeadByCampaignId = async (data) => {
    // ?campaign_id=CPPCPP7270&supplier_type=all&next_page=0&city=&startDate=&endDate=&search=
    let params = '?campaign_id=' + data.campaign_id;
    params += '&supplier_type=all';
    params += '&search=' + data.leadSearch;
    params += '&lead_type=' + data.lead_type;
    params += '&next_page=' + data.next_page;
    params += '&city=';
    params += '&startDate=&endDate=';
    let res = await APIService.get(`${Apis.Lead_By_Campaign}${params}`);
    if (res.status == 200) {
      const { data } = res;
      setLeadsByCampaign({ ...data });
    };
  };

  const getClientStatusList = async (data) => {
    let res = await APIService.get(`${Apis.Client_Status_By_Campaign}`);
    if (res.status == 200) {
      let status = res?.data?.client_status.map((item, index) => ({
        ...item,
        label: item.status_name,
        value: item.status_name,
      }));
      SetClientStatus(status);
      return status;
    };
  };

  const updateClientStatus = async (data) => {
    let update = data;
    let res = await APIService.post(`${Apis.Update_Client_Status}`, { data: data });
    if (res.status == 200) {
      SweetAlert(res.data, 'success');
      let newList = [];
      let tempData = LeadsByCampaign['values'];
      for (let i in tempData) {
        if (tempData[i][0]._id == update[0]._id) {
          let temp = [];
          for (let j in tempData[i]) {
            if (tempData[i][j]._id == update[0]._id) {
              temp.push({
                ...tempData[i][j],
                macchadalo_client_status: update[0]['macchadalo_client_status'],
              });
            } else {
              temp.push({ ...tempData[i][j] });
            }
          }
          newList.push([...temp]);
        } else {
          newList.push(tempData[i]);
        }
      }
      setLeadsByCampaign({ ...LeadsByCampaign, values: newList });
    } else {
      SweetAlert(res.data, 'error');
    }
  };

  const SendEmailsByCampaign = async (data) => {
    let params = '?campaign_id=' + data.campaign_id;
    params += '&supplier_type=all';
    params += '&lead_type=Leads';
    params += '&emails=' + data.emails;
    params += '&Client_Status=' + data.emailType;
    params += '&tabname=' + '';
    let res = await APIService.get(`${Apis.SendEmail_By_Campaign}${params}`);
    if (res.status == 200) {
      SweetAlert(Labels.Email_Success, 'success');
      setError(false);
    }
  };

  const getCommentListByIds = async (data) => {
    let params =
      '?requirement_id=' +
      data.requirement_id +
      '&_id=' +
      data._id +
      '&comment_type=' +
      data.comment_type;
    let res = await APIService.get(`${Apis.Get_Comment_List}${params}`);
    if (res.status == 200) SetCommentListAtom([...res.data])
  };

  const postCommentById = async (data) => {
    let res = await APIService.post(`${Apis.Get_Comment_List}`, { data: data });
    if (res.status == 200) {
      SweetAlert(res.data, 'success');
      getCommentListByIds({ ...data[0], comment_type: 'all' });
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const acceptDeclineLeads = async (data) => {
    let update = data;
    let res = await APIService.post(`${Apis.Accept_Decline_Leads}`, { data: data });
    if (res.status == 200) {
      SweetAlert(res.data, 'success');
      if (update[0].client_status == 'Accept') {
        let newList = LeadsByCampaign.values.filter((data) => data[0]._id !== update[0]?._id);
        setLeadsByCampaign({ ...LeadsByCampaign, values: newList });
      } else {
        let newList = [];
        let tempData = LeadsByCampaign['values'];
        for (let i in tempData) {
          if (tempData[i][0]._id == update[0]._id) {
            let temp = [];
            for (let j in tempData[i]) {
              if (tempData[i][j]._id == update[0]._id) {
                temp.push({
                  ...tempData[i][j],
                  client_status: update[0]['client_status'],
                });
              } else {
                temp.push({ ...tempData[i][j] });
              }
            }
            newList.push([...temp]);
          } else {
            newList.push(tempData[i]);
          }
        }
        setLeadsByCampaign({ ...LeadsByCampaign, values: newList });
      }
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const downloadLeadsSummary = (id) => {
    let url = `${process.env.REACT_APP_MAIN_SITE_URL}/v0/ui/b2b/download-leads-summary/?lead_type=${filters.lead_type}&supplier_code=${filters.supplier_type}&campaign_id=${id}`;
    if (filters?.start_date && filters?.end_date) {
      url +=
        '&start_date=' +
      dateFormate(filters.start_date, 'DD-MM-YYYY') +
        '&end_date=' +
        dateFormate(filters.end_date, 'DD-MM-YYYY');
    }

    if (filters?.start_acceptance_date && filters?.end_acceptance_date) {
      url +=
        '&start_acceptance_date=' +
      dateFormate(filters.start_acceptance_date, 'DD-MM-YYYY') +
        '&end_acceptance_date=' +
        dateFormate(filters.end_acceptance_date, 'DD-MM-YYYY');
    }
    if (filters?.start_update_date && filters?.end_update_date) {
      url +=
        '&start_update_date=' +
      dateFormate(filters.start_update_date, 'DD-MM-YYYY') +
        '&end_update_date=' +
        dateFormate(filters.end_update_date, 'DD-MM-YYYY');
    }
    if (filters?.city) {
      url += '&city=' + filters.city;
    }
    if (filters?.client_status) {
      url += `&client_status=${filters.client_status}`;
    }
    if (filters?.from_primary_count && filters?.to_primary_count) {
      url +=
        '&from_primary_count=' +
        filters.from_primary_count +
        '&to_primary_count=' +
        filters.to_primary_count;
    }
    window.open(url, '_blank');
  };

  const uploadCommentFile = async (file) => {
    let res = await APIService.post(`${Apis.Upload_Comments_File}`, file, true);
    if (res.status == 200) {
      SweetAlert(res.data, 'success');
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };
  const getSupplierLeadsById = async (id) => {
    let res = await APIService.get(`${Apis.Get_Leads_By_Supplier}${id}`);
    if (res.status == 200) SetCommentListAtom([...res.data]);
  };

  return {
    getAllCampaigns,
    getLeadByCampaignId,
    getClientStatusList,
    SendEmailsByCampaign,
    updateClientStatus,
    getCommentListByIds,
    postCommentById,
    acceptDeclineLeads,
    downloadLeadsSummary,
    uploadCommentFile,
    getSupplierLeadsById,
  };
};
export { newLeadActions };
